import { render, staticRenderFns } from "./PermPlacementDetailsPdf.vue?vue&type=template&id=5995004c&scoped=true&"
import script from "./PermPlacementDetailsPdf.vue?vue&type=script&lang=js&"
export * from "./PermPlacementDetailsPdf.vue?vue&type=script&lang=js&"
import style0 from "./PermPlacementDetailsPdf.vue?vue&type=style&index=0&id=5995004c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5995004c",
  null
  
)

export default component.exports